import { BellOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Badge, Button, Divider, Popover, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import type { RequestSummary } from '../api/types';

/** D-12 dự phòng: chuông hỏi máy chủ mỗi 60 giây, đổi tiêu đề tab khi có yêu cầu chờ. */
export function NotificationBell() {
  const nav = useNavigate();
  const q = useQuery({
    queryKey: ['request-summary'],
    queryFn: () => api.get<RequestSummary>('/admin/rental-requests/summary'),
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
  const s = q.data;
  const baseTitle = useRef(document.title);
  useEffect(() => {
    document.title = s?.pending ? `(${s.pending}) ${baseTitle.current}` : baseTitle.current;
  }, [s?.pending]);

  const go = (path: string) => nav(path);
  const content = (
    <div style={{ width: 280 }}>
      {!s ? (
        <Typography.Text type="secondary">Đang tải…</Typography.Text>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }}>
          <a onClick={() => go('/requests?status=pending')}>
            {s.pending} yêu cầu mới chờ tiếp nhận
          </a>
          <a onClick={() => go('/requests?unassigned=true')}>
            {s.unassigned} yêu cầu chưa phân công
          </a>
          <a onClick={() => go('/requests')}>{s.mine_open} yêu cầu bạn đang phụ trách</a>
          {s.failed_notifications_7d > 0 && (
            <a onClick={() => go('/integrations/zalo-oa')}>
              <Typography.Text type="danger">
                {s.failed_notifications_7d} thông báo Zalo gửi lỗi (7 ngày)
              </Typography.Text>
            </a>
          )}
          {s.latest_pending && (
            <>
              <Divider style={{ margin: '4px 0' }} />
              <a onClick={() => go(`/requests/${s.latest_pending!.id}`)}>
                Mới nhất: {s.latest_pending.request_code} – {s.latest_pending.contact_name} (
                {dayjs(s.latest_pending.created_at).format('DD/MM HH:mm')})
              </a>
            </>
          )}
        </Space>
      )}
    </div>
  );
  return (
    <Popover content={content} title="Yêu cầu thuê" trigger="click" placement="bottomRight">
      <Button type="text" aria-label="Thông báo yêu cầu thuê">
        <Badge count={s?.pending ?? 0} size="small">
          <BellOutlined style={{ fontSize: 18 }} />
        </Badge>
      </Button>
    </Popover>
  );
}
